<div class="example">
  <h2>Example sprites</h2>
  <div class="example-sprites-wrapper">
    <div class="example-sprite">
      <img src="../../assets/img/megaman.gif" alt="megaman" width="100px">
    </div>
    <div class="example-sprite">
      <img src="../../assets/img/megaman.gif" alt="megaman" width="100px">
    </div>
    <div class="example-sprite">
      <img src="../../assets/img/megaman.gif" alt="megaman" width="100px">
    </div>
    <div class="example-sprite">
      <img src="../../assets/img/megaman.gif" alt="megaman" width="100px">
    </div>
    <div class="example-sprite">
      <img src="../../assets/img/megaman.gif" alt="megaman" width="100px">
    </div>
  </div>
</div>
